import { LaasSettingService } from './laas-setting.service';
import { GlobalConstants } from '../constants/global-constants.constant';
import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { RouteStateService } from './route-state.service';
import { environment } from '../../../environments/environment';
import { MenuItem } from 'primeng/api';
import { UserFavoriteMenuResp } from '../models/menu/user-favorite-menu-resp';
import { Menu } from 'server/entity/menu';
import { UserRecentSearchMenuResponse } from '../models/menu/user-recent-search-menu-response';
import { AnyARecord } from 'dns';
import { AuthenticationService } from './authentication-service.service';

@Injectable({ providedIn: 'root' })
export class MenuService {
  menuUrl: string = environment.authUrl + '/menu';
  public toggleMenuBar: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public isRwd: BehaviorSubject<boolean>;

  constructor(private http: HttpClient, 
    private readonly authenticationService: AuthenticationService,
  ) {
    this.isRwd = new BehaviorSubject<boolean>(false);
  }

  public getAllMenu(): Observable<Menu[]> {
    const url = `${this.menuUrl}/getAllMenu`;
    return this.http.get<Menu[]>(url);
  }

  public getMenuDataByPosition(position: string,uuid:string): Observable<any> {
    const url = `${this.menuUrl}/getMenuByPositionAndPermission/${position}/${uuid}`;
    return this.http.get(url);
  }

  public getAllAuthorizedMenu(uuid:string): Observable<UserFavoriteMenuResp[]> {
    const url = `${this.menuUrl}/getAllAuthorizedMenu/${uuid}`;
    return this.http.get<UserFavoriteMenuResp[]>(url);
  }

  public addFavoriteMenu(request: any): Observable<any> {
    const url = `${this.menuUrl}/addFavoriteMenu`;
    return this.http.post(url, request);
  }

  public deleteFavoriteMenu(request: any): Observable<any> {
    const url = `${this.menuUrl}/deleteFavoriteMenu`;
    return this.http.post(url, request);
  }

  public getUserRecentSearchMenu(uuid:string): Observable<UserRecentSearchMenuResponse[]> {
    const url = `${this.menuUrl}/getUserRecentSearchMenus/${uuid}`;
    return this.http.get<UserRecentSearchMenuResponse[]>(url);
  }

  public saveUserRecentSearchMenu(request: any): Observable<void> {
    const url = `${this.menuUrl}/updateRecentSearchMenu`;
    return this.http.post<void>(url, request);
  }
}
